import { elementExists } from '../utils';
import { eventBus } from '../services';
const CartAlert = function () {
  const cartAlert = document.querySelector('[sh-cart-alert]');
  if (elementExists(cartAlert)) {
    const btnClose = cartAlert.querySelector('[sh-cart-alert-close]');
    const text = cartAlert.querySelector('[sh-cart-alert-text]');
    eventBus.on(eventBus.types.AddedToCart, function ($event) {
      const variant = $event.detail.variant;
      if ($event.detail.variant != null) {
        text.innerText = $event.detail.variant.title;
        cartAlert.classList.add('active');
        // setTimeout( function(){
        //     cartAlert.classList.remove( 'active' );
        // }, 10000);
      }
    });
    btnClose.addEventListener('click', function (e) {
      e.preventDefault();
      cartAlert.classList.remove('active');
    });
  }
};

export default CartAlert;
